module.exports = __webpack_public_path__ + "static/img/08-人大附中经济开发区学校1.7fcea8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/08-人大附中经济开发区学校1.png
// module id = qVp3
// module chunks = 0